import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { UsuarioModel } from 'src/app/shared/models/usuario.model';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  constructor(
    private _httpClient: HttpClient,
    private _authenticationService: AuthenticationService
  ) { }

  private get base() {
    return `${this._authenticationService.baseUrl}/Usuarios`;
  }

  public obterTodos() {
    return this._httpClient.get<ApiResponse<UsuarioModel[]>>(`${this.base}/ObterTodos`);
  }
}
